import { createSelector } from 'reselect';

export const getById = ({ substanceTR }) => substanceTR.byId;
export const getIds = ({ substanceTR }) => substanceTR.list.allIds;
export const getSubstanceTRList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));


export const getSubstanceTRBySubstanceId = (state, substanceId) => getSubstanceTRList(state).filter(elem => elem.SubstanceId === substanceId);

